import axios from "axios";
import { toast } from "react-toastify";

export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_FAILURE = "REGISTER_FAILURE";

export const VERIFY_MOBILE_AND_EMAIL_REQUEST = "VERIFY_MOBILE_AND_EMAIL_REQUEST";
export const VERIFY_MOBILE_AND_EMAIL_SUCCESS = "VERIFY_MOBILE_AND_EMAIL_SUCCESS";
export const VERIFY_MOBILE_AND_EMAIL_FAILURE = "VERIFY_MOBILE_AND_EMAIL_FAILURE";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const VERIFY_OTP_FAILURE = "VERIFY_OTP_FAILURE";

export const SOCIAL_LOGIN_USER_REQUEST = "SOCIAL_LOGIN_USER_REQUEST";
export const SOCIAL_LOGIN_USER_SUCCESS = "SOCIAL_LOGIN_USER_SUCCESS";
export const SOCIAL_LOGIN_USER_FAILURE = "SOCIAL_LOGIN_USER_FAILURE";

export const GET_PROFILE_DATA_REQUEST = "GET_PROFILE_DATA_REQUEST";
export const GET_PROFILE_DATA_SUCCESS = "GET_PROFILE_DATA_SUCCESS";
export const GET_PROFILE_DATA_FAILURE = "GET_PROFILE_DATA_FAILURE";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const IS_EXIST_PHONE_NUMBER_REQUEST = "IS_EXIST_PHONE_NUMBER_REQUEST";
export const IS_EXIST_PHONE_NUMBER_SUCCESS = "IS_EXIST_PHONE_NUMBER_SUCCESS";
export const IS_EXIST_PHONE_NUMBER_FAILURE = "IS_EXIST_PHONE_NUMBER_FAILURE";
export const RESET_IS_EXIST = "RESET_IS_EXIST";
export const RESET_REGISTER = "RESET_REGISTER";

export const UPDATE_PHONE_NUMBER_REQUEST = "UPDATE_PHONE_NUMBER_REQUEST";
export const UPDATE_PHONE_NUMBER_SUCCESS = "UPDATE_PHONE_NUMBER_SUCCESS";
export const UPDATE_PHONE_NUMBER_FAILURE = "UPDATE_PHONE_NUMBER_FAILURE";

export const SEND_OTP_REQUEST = "SEND_OTP_REQUEST";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_FAILURE = "SEND_OTP_FAILURE";

export const VERIFY_OTP_REQUEST_FOR_PHONE = "VERIFY_OTP_REQUEST_FOR_PHONE";
export const VERIFY_OTP_SUCCESS_FOR_PHONE = "VERIFY_OTP_SUCCESS_FOR_PHONE";
export const VERIFY_OTP_FAILURE_FOR_PHONE = "VERIFY_OTP_FAILURE_FOR_PHONE";

export const registerAction = (userData) => {
  return async (dispatch) => {
    try {
      const language = localStorage.getItem("language");
      dispatch({ type: REGISTER_REQUEST, payload: userData });
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/register/user/website/v1`,
        userData
      );
      dispatch({ type: REGISTER_SUCCESS, payload: response?.data });
      const successMessage = language === "Italian" ? "Abbiamo inviato un codice di verifica alla tua email" : "We have sent a verification code to your email";
      toast.success(successMessage);
    } catch (error) {
      console.error(error);
      dispatch({ type: REGISTER_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message);
    }
  };
};


export const verifyMobileAndEmailAction = (userData) => {
  return async (dispatch) => {
    const language = localStorage.getItem("language");
    try {
      dispatch({ type: VERIFY_MOBILE_AND_EMAIL_REQUEST, payload: userData });
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/check/mobile/email/before/register/v1`,
        { email: userData.email, phone: userData.phone }
      );
      dispatch({ type: VERIFY_MOBILE_AND_EMAIL_SUCCESS, payload: response?.data });
      // console.log("response?.data", response?.data);
    } catch (error) {
      dispatch({ type: VERIFY_MOBILE_AND_EMAIL_FAILURE, payload: error.message });
    }
  }
}


export const verifyOtpAction = (otp) => {
  return async (dispatch) => {
    try {
      dispatch({ type: VERIFY_OTP_REQUEST, payload: otp });
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/verify/register/website/otp`,
        otp
      );
      // Store the token from the response
      if (response?.data?.token) {
        localStorage.setItem("Authorization", response?.data?.token);
      }
      dispatch({ type: VERIFY_OTP_SUCCESS, payload: response?.data });
    } catch (error) {
      dispatch({ type: VERIFY_OTP_FAILURE, payload: error.message });
      // toast.error(error?.response?.data?.message);
    }
  };
};

export const updatePhoneNumberAction = (phone) => {
  return async (dispatch) => {
    try {

      const language = localStorage.getItem("language");
      const token = localStorage.getItem("Authorization");
      dispatch({ type: UPDATE_PHONE_NUMBER_REQUEST, payload: phone });
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/user/update/phone/v1`,
        phone,
        {
          headers: {
            Authorization: token
          }
        }
      );
      const successMessage = language === "Italian" ? "Numero di telefono aggiornato con successo" : "Phone number updated successfully";
      toast.success(successMessage);
      dispatch({ type: UPDATE_PHONE_NUMBER_SUCCESS, payload: response?.data });
    } catch (error) {
      dispatch({ type: UPDATE_PHONE_NUMBER_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message);
    }
  }
}

export const loginAction = (userData) => {
  return async (dispatch) => {
    try {
      const language = localStorage.getItem("language");
      dispatch({ type: LOGIN_REQUEST, payload: userData });
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/login/user/v1`,
        userData
      );
      dispatch({ type: LOGIN_SUCCESS, payload: response?.data });
      const successMessage = language === "Italian" ? "Login effettuato con successo" : "Login successfull";
      toast.success(successMessage);
    } catch (error) {
      console.error(error);
      dispatch({ type: LOGIN_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message);
    }
  };
};

export const sendOtpAction = (userData) => {
  return async (dispatch) => {
    try {
      const language = localStorage.getItem("language");
      dispatch({ type: SEND_OTP_REQUEST, payload: userData });
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/send/phone/otp/v1`,
        userData
      );
      dispatch({ type: SEND_OTP_SUCCESS, payload: response?.data });
      const successMessage = language === "Italian" ? "Codice di verifica inviato con successo" : "Verification code sent successfully";
      toast.success(successMessage);
    } catch (error) {
      console.error(error);
      dispatch({ type: SEND_OTP_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message);
    }
  };
};


export const verifyOtpActionForPhone = (userData) => {
  return async (dispatch) => {
    try {
      const language = localStorage.getItem("language");
      dispatch({ type: VERIFY_OTP_REQUEST_FOR_PHONE, payload: userData });

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/verify/phone/otp/v1`,
        userData
      );

      // Store the token from the response
      if (response?.data?.token) {
        localStorage.setItem("Authorization", response?.data?.token);
      }

      dispatch({ type: VERIFY_OTP_SUCCESS_FOR_PHONE, payload: response?.data });

      const successMessage = language === "Italian"
        ? "Codice di verifica verificato con successo"
        : "Verification code verified successfully";
      toast.success(successMessage);

      return response.data;
    } catch (error) {
      console.error(error);
      dispatch({ type: VERIFY_OTP_FAILURE_FOR_PHONE, payload: error.message });
      toast.error(error?.response?.data?.message || "Verification failed");
      throw error;
    }
  };
};


export const socialLoginUser = (data, navigate) => {
  return async (dispatch) => {
    try {
      const language = localStorage.getItem("language");
      dispatch({ type: SOCIAL_LOGIN_USER_REQUEST });
      const url = `${process.env.REACT_APP_BASE_URL}/user/web/social/login`;
      const response = await axios.post(url, data);
      localStorage.setItem("Authorization", response?.data?.token);
      dispatch({ type: SOCIAL_LOGIN_USER_SUCCESS, payload: response.data });
      // Check if login was successful
      if (response?.data?.status === 200 || response?.data?.status === 201) {
        const profileData = response?.data?.data;

        if (!profileData?.nation_country?.id && !profileData?.gender?.name && !profileData?.city?.id && !profileData?.region_state?.id && !profileData?.dob?.date && !profileData?.education?.name && !profileData?.civilState?.name) {
          const successMessage = language === "Italian"
            ? "Completa il tuo profilo per continuare."
            : "Please complete your profile to continue.";
          toast.success(successMessage);
          navigate("/complete-profile");
        } else {
          // Check for stored redirect path first
          const storedRedirectPath = localStorage.getItem('redirectAfterLogin');
          if (storedRedirectPath) {
            localStorage.removeItem('redirectAfterLogin'); // Clear the stored path
            navigate(storedRedirectPath);
          } else {
            navigate("/");
          }
          const successMessage = language === "Italian" ? "Login effettuato con successo" : "Login successful";
          toast.success(successMessage);
        }
      }
    } catch (error) {
      console.error("error", error);
      dispatch({ type: SOCIAL_LOGIN_USER_FAILURE, payload: error });
      toast.error(error?.response?.data?.message);
    }
  };
};


export const getProfileDataAction = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_PROFILE_DATA_REQUEST });
      const token = localStorage.getItem("Authorization");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/details/v1`,
        {
          headers: {
            Authorization: token
          }
        }
      );
      dispatch({ type: GET_PROFILE_DATA_SUCCESS, payload: response?.data });
    } catch (error) {
      dispatch({
        type: GET_PROFILE_DATA_FAILURE,
        payload: error?.response?.data?.message
      });
      toast.error(error?.response?.data?.message);
    }
  };
};


export const isExistPhoneNumberAction = (phone) => {
  return async (dispatch) => {
    try {
      dispatch({ type: IS_EXIST_PHONE_NUMBER_REQUEST });
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/exist/phone/v1`,
        { phone }
      );
      dispatch({ type: IS_EXIST_PHONE_NUMBER_SUCCESS, payload: response?.data });
    } catch (error) {
      console.log("error", error?.response?.data);
      dispatch({ type: IS_EXIST_PHONE_NUMBER_FAILURE, payload: error?.response?.data });
      // const language = localStorage.getItem("language");
      // if (error.response && error.response.data && error.response.data.message) {
      //   toast.error(language === "Italian" ? "Prova a usare l'email o un altro numero di telefono" : "Please try using email or another phone number");
      // } else {
      //   toast.error(language === "Italian" ? "Si è verificato un errore durante il controllo del numero di telefono." : "An error occurred while checking the phone number.");
      // }
    }
  };
};

export const resetRegisterAction = () => {
  return (dispatch) => {
    dispatch({ type: RESET_REGISTER });
  };
};

